import React, { Component } from 'react';
import { compose } from 'recompose';
import { StaggeredMotion, spring } from 'react-motion';
import uuid from 'uuid';

import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import { withStyles } from '@material-ui/core/styles';

import InvoicePreview from './Invoice/InvoicePreview';
import InvoiceTask from './InvoiceTasks/InvoiceTask';

const styles = theme => ({
  root: {
    maxWidth: '400px',
  },
  header: {
  }
});

//TODO: move preview dialog callbacks and its state handling to the root of the app
// and handle the state in redux
class InvoiceTasks extends Component {
  constructor(props){
    super(props);
    this.state = {
      showPreview: false
    }
  }

  handlePreviewOpen = () => {
    window.scrollTo(0, 0);
    this.setState({showPreview: true});
  }

  handlePreviewClose = () => {
    this.setState({showPreview: false});
  }

  render(){
    const { classes, invoice, schedule, project}  = this.props;
    const startHeight = 50;
    const endHeight = 70;

    const invoiceTasks =[
      <InvoiceTask
        type="create"
        invoice={invoice}
        schedule={schedule}
        project={project}
      />,
      <InvoiceTask
        type="approve"
        invoice={invoice}
        schedule={schedule}
        project={project}
      />,
      <InvoiceTask
        type="send"
        invoice={invoice}
        schedule={schedule}
        project={project}
        handlePreviewOpen={this.handlePreviewOpen.bind(this)}
        handlePreviewClose={this.handlePreviewClose.bind(this)}
      />,
      <InvoiceTask
        type="pay"
        invoice={invoice}
        schedule={schedule}
        project={project}
      />
    ];

    return(
      <div key={uuid.v4()} className={classes.root}>
        <InvoicePreview
          invoice={invoice}
          showPreview={this.state.showPreview}
          handleClose={this.handlePreviewClose}
        />
        <StaggeredMotion
           defaultStyles={[
             {h: startHeight, opacity: 0},
             {h: startHeight, opacity: 0},
             {h: startHeight, opacity: 0},
             {h: startHeight, opacity: 0}
           ]}
           styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => {
             return i === 0
               ? {
                  h: spring(endHeight),
                  opacity: spring(1, { stiffness: 30, damping: 10})
                  }
               : {
                  h: spring(prevInterpolatedStyles[i - 1].h),
                  opacity: spring(prevInterpolatedStyles[i - 1].opacity)
                  }
           })}>
           {interpolatingStyles =>
             <List>
               {interpolatingStyles.map((style,i) => {
                 return (
                  <div key={i} >
                    <div style={{height: style.h, opacity: style.opacity}}>
                      {invoiceTasks[i]}
                    </div>
                    <Divider style={{opacity: style.opacity}} inset component="li" />
                   </div>
                 );
               })}
             </List>
           }
         </StaggeredMotion>
      </div>
    );
  }
}


export default compose(
  withStyles(styles)
)(InvoiceTasks);



// WEBPACK FOOTER //
// ./src/components/admin/InvoiceTasks.jsx